import { use } from 'react'

import { FeaturesContext, type FeaturesState } from './FeaturesContext'

export function useFeatures(): FeaturesState {
  const state = use(FeaturesContext)
  if (!state) throw new Error('useFeatures must be used inside a FeaturesProvider')
  return state
}
